import { useLazyQuery } from '@apollo/client';
import { useContext } from 'react';

import { Arrayable } from '../../../../helper/array';
import { toOrderByInput } from '../../../../helper/sort';
import SortBy from '../../../../models/SortBy';
import SubEvent, { SubEventFilterInput, SubEventOrderByInput } from '../../models/SubEvent';
import { MasterEventContext } from '../../pages/MasterEvent';
import { GET_SUBEVENTS } from './query';

interface QueryData {
  subEvents: SubEvent[];
}

interface QueryVars {
  orderBy?: Arrayable<SubEventOrderByInput>;
  where: Pick<SubEventFilterInput, 'masterEventId'>;
}

/**
 * Fetch sub events of the current selected master event
 */
function useFetchSubEvents() {
  const { masterEvent } = useContext(MasterEventContext);

  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVars>(GET_SUBEVENTS, {
    notifyOnNetworkStatusChange: true,
  });

  const fetchSubEvents = async (masterEventIds?: string[], sortBy?: SortBy) => {
    const variables: QueryVars = {
      orderBy: toOrderByInput(sortBy),
      where: {
        masterEventId: masterEventIds ? { _in: masterEventIds } : { _eq: masterEvent._id },
      },
    };

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return response.data?.subEvents || [];
  };

  return {
    fetchSubEvents,
    loading,
    error,
    subEvents: data?.subEvents || [],
  };
}

export default useFetchSubEvents;
